import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { FaCircleChevronDown, FaCircleChevronUp } from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/user-dashboard/Sidebar";
import Footer from "../../components/Footer";

const Profile = () => {
  const { isLoggedIn } = useSelector((state) => state.user);
  const navigate = useNavigate();
  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    } else {
      // toast.success("User Profile Loaded Successfully")
    }
  }, [isLoggedIn]);
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if window width is small
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768); // adjust breakpoint as needed
    if (window.innerWidth >= 768)
      setIsOpen(true); // always open on desktop
    else setIsOpen(false); // closed by default on mobile
  };

  useEffect(() => {
    handleResize(); // check initial width
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="bg-black">
        <Navbar />
      </div>
      <div className="flex flex-col md:flex-row justify-center items-start gap-4 py-12 px-4 md:px-16 lg:px-24">
        {/* <div className="flex-[0.3] shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-[2rem] px-[2rem]">
          <hr />
          <Sidebar />
          <hr />
        </div> */}
        <div className="shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-8 px-4 w-full md:w-[300px] bg-white rounded-lg">
          {/* Toggle button on mobile */}
          {isMobile && (
            <div
              className="flex justify-between items-center cursor-pointer mb-4"
              onClick={() => setIsOpen(!isOpen)}
            >
              <h2 className="font-semibold text-lg">Menu</h2>
              {isOpen ? (
                <FaCircleChevronUp size={24} />
              ) : (
                <FaCircleChevronDown size={24} />
              )}
            </div>
          )}

          {/* Sidebar content */}
          {isOpen && (
            <div className="overflow-hidden transition-all duration-300">
              <Sidebar close={() => setIsOpen(false)} isMobile={isMobile} />
            </div>
          )}
        </div>
        <div className="w-full md:w-auto flex-1 shadow-[0_3px_8px_rgba(0,0,0,0.24)] py-[3rem]">
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Profile;
